<template>
  <div class="filter-container">
    <b-field horizontal :label="`${this.label}:`">
      <b-input :value="query[0] && query[0].value"
        @input="(v) => $emit('input', getResult(v))"/>
    </b-field>
  </div>
</template>


<script>
export default {
  props: {
    queryKey: String,
    label: String,
    query: { type: Array, default: () => [] },
  },
  methods: {
    getResult(v) {
      return [{
        label: `${this.label} ${v}`,
        value: v,
        queryKey: this.queryKey,
      }];
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
